<template>
<bk-input type="password"
          :value="password"
          :valid="valid"
          :pristine="pristine"
          :label="$t('PASSWORD.PLACEHOLDER')"
          :disabled="disabled"
          icon="lock"
          :helper-text="$t(state)"
          @input="changePassword"
          :id="id"
          :max-length="15"
          :allow-hotjar-recording="allowHotjarRecording"
          :trim="false"
/>
</template>
<script>
import { PasswordState } from '../../../mixins/passwordCheck'
import BkInput from '../../../common/BkInput'

export default {
  components: {
    BkInput,
  },
  data () {
    return {
      /**
       * Indicator if the field is unchanged
       */
      pristine: true
    }
  },
  props: {
    /**
     * Allow recording in HotJar by setting the appropriate classes to the input field
     */
    allowHotjarRecording: {
      type: Boolean,
      default: false
    },
    /**
     * the value of the current selected password
     */
    password: {
      type: String,
      required: true,
    },
    /**
     * If is true the password is valid
     */
    valid: {
      type: Boolean,
      default: true
    },
    /**
     * The state of the password field
     */
    state: {
      type: String,
      required: true,
      validator (state) {
        return Object.values(PasswordState).indexOf(state) !== -1
      },
    },
    id: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * Fire the change event for the password
     * And change
     * @param password
     */
    changePassword (password) {
      this.$emit('change', password)
      this.pristine = false
    }
  },
}
</script>

